import React, { useState } from 'react';

// A password <input> with an eye at its right edge that shows what was typed, and hides it again —
// the web's counterpart of ParksphereMobileApp/components/PasswordInput.js.
//
// Takes the same props as the <input> it replaces (className, id, value, onChange, required...).
// The toggle's look is set inline on purpose: Auth.css styles every <button> in the sign-in form as
// a purple pill (`.auth-page-wrapper .auth-container button`, plus :hover and :active rules), and
// only inline styles reliably win against all three without a specificity race.
const EyeIcon = ({ crossed }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
    {crossed && <line x1="3" y1="3" x2="21" y2="21" />}
  </svg>
);

const wrapStyle = { position: 'relative', display: 'block', width: '100%' };
const buttonStyle = {
  position: 'absolute',
  right: 6,
  top: '50%',
  transform: 'translateY(-50%)',
  width: 34,
  height: 34,
  margin: 0,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  border: 'none',
  borderRadius: '50%',
  color: '#8b86a0',
  cursor: 'pointer',
};

const PasswordField = ({ style, ...props }) => {
  const [visible, setVisible] = useState(false);
  return (
    <span style={wrapStyle}>
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        style={{ ...style, width: '100%', boxSizing: 'border-box', paddingRight: 44 }}
      />
      <button
        type="button"
        style={buttonStyle}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
      >
        <EyeIcon crossed={visible} />
      </button>
    </span>
  );
};

export default PasswordField;
